




























import Vue from "vue";

import BlogPostData from "@/data/BlogPostData.ts";

export default Vue.extend({
    name: "BlogPostList",
    components: {

    },
    props: {
        blogPosts: Array
    },
    methods: {
        moveTo: function(item: BlogPostData) {
            this.$router.push(item.pathToPage);
        }
    },
});
